export default "__VITE_ASSET__BZtxZDmq__"